module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/static-modal-app/img/layer-4__27e7fd20e10c3f745a3781c78949159c.png";